import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'langUrl',
  standalone: true
})
export class LangUrlPipe implements PipeTransform {

  public transform(val: string): string {
    return val.langUrl();
  }
}
